import { version } from '../styles.js';
let _moduleType = 'ESM';
export const meta = {
  version,
  module: _moduleType,
};
